/**
 * Drawn stickers: art that is not an emoji -- dog ears, a flower crown, a
 * mustache -- for laying on faces. Each is an SVG in web/public/art/, named
 * here, and a sticker of one stores only its name; the server keeps no name
 * that is not on this list (snapDecorOf).
 */
export const STICKER_ART = [
  'dog-ears',
  'dog-nose',
  'cat-ears',
  'cat-whiskers',
  'bunny-ears',
  'bunny-nose',
  'flower-crown',
  'mustache',
  'aviators',
  'party-hat',
  'halo',
  'devil-horns',
] as const;

export type StickerArt = (typeof STICKER_ART)[number];

export function isStickerArt(name: unknown): name is StickerArt {
  return typeof name === 'string' && (STICKER_ART as readonly string[]).includes(name);
}

/** Where its picture is, on the app's own site. */
export function artUrl(name: StickerArt): string {
  return `/art/${name}.svg`;
}
